import axios from 'axios'

const TRANSPARENT_PIXEL = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=='

export default {
    data() {
        return {
            gifFrameCache: {},
            gifFramePending: {}
        }
    },
    methods: {
        isGifSrc(src) {
            if (!src || typeof src !== 'string') {
                return false
            }

            return /\.gif$/i.test(src.split('?')[0])
        },
        isSvgSrc(src) {
            if (!src || typeof src !== 'string') {
                return false
            }

            return /\.svg$/i.test(src.split('?')[0])
        },
        objectPlayerSrc(object) {
            if (!object || !object.id) {
                return ''
            }

            if (this.isGifSrc(object.id)) {
                return this.gifFrameCache[object.id] || TRANSPARENT_PIXEL
            }

            return this.graphicsUrl + object.id
        },
        ensureFrozenGif(filename) {
            if (!this.isGifSrc(filename)) {
                return Promise.resolve('')
            }

            if (this.gifFrameCache[filename]) {
                return Promise.resolve(this.gifFrameCache[filename])
            }

            return this.freezeGifFrame(filename)
        },
        freezeGifFrame(filename) {
            if (this.gifFramePending[filename]) {
                return this.gifFramePending[filename]
            }

            const fileUrl = this.graphicsUrl + filename
            const pending = axios.get(
                `${this.$hostname}/admin/services/graphics/file`,
                {
                    params: {
                        url: fileUrl
                    },
                    headers: {
                        Authorization: 'Bearer ' + (this.token || localStorage.getItem('token'))
                    },
                    responseType: 'blob'
                }
            ).then((response) => {
                return new Promise((resolve) => {
                    const blobUrl = URL.createObjectURL(response.data)
                    const img = new Image()

                    img.onload = () => {
                        try {
                            const canvas = document.createElement('canvas')
                            canvas.width = img.naturalWidth || img.width
                            canvas.height = img.naturalHeight || img.height
                            canvas.getContext('2d').drawImage(img, 0, 0)
                            const dataUrl = canvas.toDataURL('image/png')
                            URL.revokeObjectURL(blobUrl)
                            this.$set(this.gifFrameCache, filename, dataUrl)
                            resolve(dataUrl)
                        } catch (e) {
                            URL.revokeObjectURL(blobUrl)
                            this.$set(this.gifFrameCache, filename, fileUrl)
                            resolve(fileUrl)
                        }
                    }

                    img.onerror = () => {
                        URL.revokeObjectURL(blobUrl)
                        this.$set(this.gifFrameCache, filename, fileUrl)
                        resolve(fileUrl)
                    }

                    img.src = blobUrl
                })
            }).catch(() => {
                this.$set(this.gifFrameCache, filename, fileUrl)
                return fileUrl
            })

            this.$set(this.gifFramePending, filename, pending)

            return pending
        },
        loadRasterGraphic(src) {
            return new Promise((resolve, reject) => {
                const img = new Image()

                img.onload = () => {
                    const size = {
                        width: img.width,
                        height: img.height
                    }

                    if (this.isGifSrc(src)) {
                        this.ensureFrozenGif(src).then(() => resolve(size), () => resolve(size))
                        return
                    }

                    resolve(size)
                }

                img.onerror = () => reject(new Error('graphic load failed'))
                img.src = this.graphicsUrl + src
            })
        },
        placeGraphicObject(object) {
            const replacing = this.is_object_changing
            this.is_object_changing = false
            this.show_svg_modal = false

            const addNew = (source, dimensions) => {
                this.default_object.z_index = (this.template.texts.length || 0) + (this.template.objects.length || 0) + 1
                const newObj = JSON.parse(JSON.stringify(this.default_object))
                newObj.id = object.src
                newObj.source = source
                if (dimensions) {
                    newObj.dimensions = dimensions
                }
                this.template.objects.push(newObj)
                this.object_positions.push(JSON.parse(JSON.stringify(this.default_positions)))
                this.active_object = this.template.objects.length - 1
                this.active_type = 'object'
                this.$nextTick(() => {
                    if (typeof this.applyObjectContainerPosition === 'function') {
                        this.applyObjectContainerPosition(this.active_object)
                    }
                })
            }

            if (!this.isSvgSrc(object.src)) {
                return this.loadRasterGraphic(object.src).then((size) => {
                    if (replacing) {
                        this.replaceActiveGraphic(object, 'Image', size.width, size.height, true)
                    } else {
                        addNew('Image', {width: size.width, height: size.height})
                    }
                }).catch((error) => {
                    console.log(error)
                })
            }

            return axios.get(
                `${this.$hostname}/admin/services/graphics/svg/source`,
                {
                    params: {
                        url: this.graphicsUrl + object.src
                    },
                    headers: {
                        Authorization: 'Bearer ' + (this.token || localStorage.getItem('token'))
                    }
                }
            ).then((response) => {
                if (replacing) {
                    const size = this.getGraphicSourceSize(response.data)
                    this.replaceActiveGraphic(
                        object,
                        response.data,
                        size ? size.width : 0,
                        size ? size.height : 0,
                        false
                    )
                } else {
                    addNew(response.data)
                }
            }).catch((error) => {
                this.loading = false
                console.log(error)
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/gifGraphic.js